import { render, staticRenderFns } from "./ClaimManagement.vue?vue&type=template&id=7df76133&scoped=true"
import script from "./ClaimManagement.vue?vue&type=script&lang=js"
export * from "./ClaimManagement.vue?vue&type=script&lang=js"
import style0 from "./ClaimManagement.vue?vue&type=style&index=0&id=7df76133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df76133",
  null
  
)

export default component.exports